import api from './api';
import ErrorService from './errorService';
import Swal from 'sweetalert2';
import Cookies from 'universal-cookie';

export const DesbloqueoService = {

    unlockCustomer: async (solicitudData) => {
        try {
            const response = await ErrorService.withTimeout(api.post('/Manager/SolicitarDesbloqueo', solicitudData));

            console.log('Respuesta de desbloqueo:', response.data);
            if (response.data.isSuccess === true) {
                Swal.fire({
                    icon: 'success',
                    title: '¡Éxito!',
                    text: 'Solicitud de desbloqueo enviada correctamente.',
                    confirmButtonText: 'Aceptar',
                });
            } else {
                Swal.fire({
                    icon: 'warning',
                    title: 'Problema al enviar la solicitud',
                    text: response.data.message,
                    confirmButtonText: 'Aceptar',
                });
            }

            return response.data;

        } catch (error) {
            ErrorService.handleApiError('Error en desbloqueo:', error);
            throw error;
        }
    },

    getUnlockRequests: async () => {
        try {
            const cookies = new Cookies();
            const token = cookies.get('tokenGcc');
            
            // Si el token es nulo, evita la llamada a la API
            if (!token) {
                console.error('No se encontró el token en las cookies.');
                return []; 
            }

            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };
            const response = await ErrorService.withTimeout(api.get('/Manager/ObtenerSolicitudesDesbloqueo', config));
            return response.data;
        } catch (error) {
            ErrorService.handleApiError('Error al obtener solicitudes de desbloqueo:', error);
            throw error;
        }
    },

    updateUnlockRequest: async (id, nuevoEstado, fechaAprobacion, usuarioAprobador) => {
        try {
            const data = {
                id: id,
                estado: nuevoEstado,
                usuarioAprueba: usuarioAprobador,
                fechaApruebo: fechaAprobacion
            };
            const cookies = new Cookies();
            const token = cookies.get('tokenGcc');
            
            if (!token) {
                console.error('No se encontró el token en las cookies.');
                return []; 
            }

            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };
            const response = await api.post('/Manager/ActualizarClasificacionManager', data, config);
            
            return response.data;
        } catch (error) {
            ErrorService.handleApiError('Error al actualizar la solicitud:', error);
            throw error;
        }
    }
};